import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const logout = graphql(gql`
  mutation Logout {
    logout {
      mutationId
    }
  }
  `,
  {
    props({ mutate }) {
      return {
        logout(variables) {
          return mutate({ variables })
        }
      }
    }
  }
)


// WEBPACK FOOTER //
// ./src/components/Logout/mutations.js